import { useEffect } from 'react';
import { InsuranceType } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/shared/enums.pb';
import { InsuranceReportPageWithErrorBoundary as InsuranceReportDXC } from '@frontend/insurance-eligibility-report';
import { InsuranceReportPage, useInsuranceReportShallowStore } from '@frontend/insurance-eligibility-report-tuuthfairy';
import { useBreakpoint } from '@frontend/responsiveness';
import { ModalControlModalProps } from '@frontend/design-system';
import { InsuranceReportModalContainer } from '../containers/insurance-report-modal-container';
import { useInsuranceTabShallowStore } from '../stores/use-insurance-tab-store';
import { SwitchToLargeModal } from './switch-to-large-modal';

interface InsuranceInlineReportProps {
  locationId: string;
  sourceId: string | undefined;
  personInfo: {
    personId: string;
    personName: string;
  };
  personPMSId: string | undefined;
  isReportOpen: boolean;
  setIsReportOpen: (isOpen: boolean) => void;
  insuranceType?: InsuranceType;
  shouldShowTuuthFairyReport: boolean;
  switchToLargeModalProps?: ModalControlModalProps;
}

export const InsuranceInlineReport = ({
  locationId,
  sourceId,
  personInfo,
  personPMSId,
  isReportOpen,
  switchToLargeModalProps,
  insuranceType = InsuranceType.INSURANCE_TYPE_PRIMARY,
  shouldShowTuuthFairyReport,
  setIsReportOpen,
}: InsuranceInlineReportProps) => {
  const size = useBreakpoint();
  const { setIsPersonId } = useInsuranceReportShallowStore('setIsPersonId');
  const isMobile =
    (size === 'xsmall' || size === 'small' || size === 'medium' || size === 'mobile') && switchToLargeModalProps;
  const { setShouldReportOpenInLargeModeSwitch } = useInsuranceTabShallowStore('setShouldReportOpenInLargeModeSwitch');

  useEffect(() => {
    //when user switches to large mode from inline report we want to open the report modal and close the inline report
    if (isMobile && isReportOpen) {
      setIsReportOpen(false);
      setShouldReportOpenInLargeModeSwitch(false);
    }
  }, [isMobile]);

  const onInsuranceReportModalClose = () => {
    setIsPersonId('');
    setIsReportOpen(false);
  };

  return (
    <>
      <InsuranceReportModalContainer isOpen={isReportOpen} setIsOpen={setIsReportOpen}>
        {shouldShowTuuthFairyReport ? (
          <InsuranceReportPage
            reportProps={{
              locationId: locationId,
              sourceId: sourceId,
              personInfo,
              personPMSId: personPMSId,
              insuranceType,
              closeInsuranceReportModal: onInsuranceReportModalClose,
            }}
          />
        ) : (
          <InsuranceReportDXC
            reportProps={{
              personId: personInfo.personId,
              locationId: locationId,
              sourceId: sourceId,
              personPMSId: personPMSId,
              closeInsuranceReportModal: onInsuranceReportModalClose,
            }}
          />
        )}
      </InsuranceReportModalContainer>
      {isMobile && <SwitchToLargeModal {...switchToLargeModalProps} onViewReport={() => setIsReportOpen(true)} />}
    </>
  );
};
